<div class="main-container">
  <div class="certificados-content">
    <span style="font-size: larger; font-weight: bold">
      Certificados De Retenciones
    </span>
    <br />
    <span style="font-size: medium; color: var(black)">
      En este módulo puedes consultar y descargar tus certificados de
      retenciones de manera individual. Podrás consultar certificados de hasta
      un año atrás.
    </span>
    <br /><br /><br />

    <form *ngIf="frmCertificadoRetencion" [formGroup]="frmCertificadoRetencion">
      <!-- DIV GENERAL -->
      <div class="form-container row">
        <!-- Primer DIV -->
        <div class="col-8 certificado-fields">
          <div class="row">
            <!-- Tipo de Certificado -->
            <div class="col-12 col-md-6 col-lg-3">
              <mat-form-field style="width: 100%">
                <mat-label>Tipo de certificado</mat-label>
                <mat-select formControlName="tipo_certificado">
                  <mat-option *ngFor="let t of tiposCertificado" [value]="t.id">
                    {{ t.nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Año -->
            <div class="col-12 col-md-6 col-lg-3">
              <mat-form-field style="width: 100%">
                <mat-label>Año</mat-label>
                <mat-select formControlName="anio">
                  <mat-option *ngFor="let a of anios" [value]="a">
                    {{ a }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Periodo -->
            <div class="col-12 col-md-6 col-lg-3">
              <mat-form-field style="width: 100%">
                <mat-label>Periodo</mat-label>
                <mat-select 
                formControlName="periodo"
                [disabled]="frmCertificadoRetencion.get('tipo_certificado')?.value === 'RF'"
                >
                  <mat-option *ngFor="let p of periodos" [value]="p.value">
                    {{ p.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- BOTON DE DESCARGA -->
        <div class="col-4 certificado-actions">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4">
              <button
                type="button"
                class="btn btn-primary btn-icon"
                (click)="generarCertificado()"
                appTrackClick 
                [trackData]="trackData"
              >
                <mat-icon>download</mat-icon>
                <span
                  >GENERAR <br />
                  CERTIFICADO <br />
                  DE RETENCIÓN</span
                >
              </button>
            </div>
          </div>
        </div>

        <ng-template #dialogDescargaExitosa let-data>
          <div class="dialog-container">
            <div class="dialog-header">Reenviar soportes al usuario</div>
            <div class="dialog-content">
              <p>Se descargó el certificado exitosamente.</p>
              <button
                mat-flat-button
                class="dialog-primary-button"
                (click)="cerrarDialogo()"
              >
                Aceptar
              </button>
            </div>
          </div>
        </ng-template>
      </div>
    </form>

    <div *ngIf="haveResponde && !haveDataToShow" class="message-container">
      <span class="message-span">{{ generalMessage.toUpperCase() }}</span>
    </div>
  </div>
</div>
